// STYLE
import './_blog.scss'

// LIBS
import React from 'react'
import {sortBy, filter, map, get} from 'lodash/fp'
import {format} from 'date-fns'

// HELPERS
import * as util from '../../lib/util.js'

// COMPONENTS
import MetaData from '../../components/meta-data'
import BlogPostItem from '../../components/blog-post-item'

// INTERFACE
export const query = graphql`
  query BlogsQuery {
    allBlogJson{
      edges {
        node {
          slug
          title
          intro
          createdAt
          imageHeader {
            fields {
              description
              file {
                url
              }
            }
          }
          blogAuthor {
            fields {
              name
              slug
              image {
                fields {
                  file {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default ({data}) => {
  // grab and sort blogPost data from graphql query result (oldest to newest)
  let nodes = sortBy(item => new Date(item.createdAt), map(get('node'), get('allBlogJson.edges', data))).reverse()
  return (
    <div className='BlogIndex'>
      <MetaData data={{
        slug: 'blog',
        title: 'Blog',
        description: 'Code Fellows Blog',
      }} />
      <div style={{paddingTop: '70px'}}>
        <div>
          {nodes.map((node, i) => <BlogPostItem key={i} blogPost={node} />)}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/blog/index.js